module.exports = __webpack_public_path__ + "static/newsletter-99d80f54e498a8e0ceaec764627f308f.svg";